<template>
  <el-dialog title="填写发货信息" :visible.sync="visible" :close-on-click-modal="false" @close="close" width="400px">
    <el-form ref="form" :model="form" :rules="rules" size="small" label-width="80px">
      <el-form-item label="快递公司" prop="kd_name">
        <el-select v-model="form.kd_name" placeholder="请选择" style="width: 100%;" @change="handleExpressChange">
          <el-option label="顺丰" value="顺丰"> </el-option>
          <el-option label="中通" value="中通"> </el-option>
          <el-option label="圆通" value="圆通"> </el-option>
          <el-option label="申通" value="申通"> </el-option>
          <el-option label="极兔" value="极兔"> </el-option>
          <el-option label="韵达" value="韵达"></el-option>
          <el-option label="京东物流" value="京东物流"></el-option>
          <el-option label="德邦物流" value="德邦物流"></el-option>
          <el-option label="邮政" value="邮政"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="快递单号" prop="kd_no">
        <el-input v-model="form.kd_no"></el-input>
      </el-form-item>
      <el-form-item label="费用" prop="kd_fee">
        <el-input-number v-model="form.kd_fee" :precision="2" :step="1" :min="0"></el-input-number>
      </el-form-item>
      <el-form-item label="收件人" prop="consignee">
        <el-input v-model="form.consignee"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer">
      <el-button @click="close">取消</el-button>
      <el-button :loading="submitting" type="primary" @click="handleSubmit">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        visible: false,
        orderId: '',
        submitting: false,
        form: {
          kd_name: '',
          kd_no: '',
          kd_fee: 0.00,
          consignee: ''
        },
        rules: {
          kd_name: [{
            required: true,
            message: '快递公司不能为空'
          }],
          kd_no: [{
            required: true,
            message: '快递单号不能为空'
          }],
          consignee: [{
            required: true,
            message: '收件人不能为空'
          }],
        }
      }
    },
    methods: {
      open(orderId) {
        this.visible = true
        this.orderId = orderId
      },
      close() {
        this.$refs.form.resetFields()
        this.visible = false
      },

      // 快递公司改变
      handleExpressChange(expressCompany) {
        // 设置快递费用
        switch (expressCompany) {
          case '顺丰':
            this.form.kd_fee = 18
            break
          case '申通':
            this.form.kd_fee = 1.8
            break
          case '极兔':
            this.form.kd_fee = 6
            break
          case '韵达':
            this.form.kd_fee = 0
            break
          case '德邦':
            this.form.kd_fee = 16
            break
          case '邮政':
            this.form.kd_fee = 15
            break
          default:
            this.form.kd_fee = 1.9
            break
        }
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (!valid) return

          this.submitting = true
          // 设置订单物流信息
          this.$util.put(`/merchant/save_kd_info/${this.orderId}`, this.form)
            .then(() => {
              this.$message.success('设置成功')
              // 通知父级
              this.$emit('set-shipment-info')
              this.close()
            })
            .finally(() => this.submitting = false)
        })
      }
    }
  }
</script>

<style>
</style>